import { useSnackbar } from "notistack";
import React, { useEffect } from "react";

import { Grid } from "@material-ui/core";
import Table from "@ds-developer/invoices-table";

import { useTealium } from "@hubcapp/context";

import { InstructorInvoicesStateProviderProps } from "./types";

import useInstructorInvoiceUrl from "./hooks/useInstructorInvoiceUrl";
import useInstructorInvoicesData from "./hooks/useInstructorInvoicesData";

const InstructorInvoices: React.FC<InstructorInvoicesStateProviderProps> = ({
  instructorId,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { trackEvent } = useTealium();
  const { data, loading } = useInstructorInvoicesData(instructorId);
  const [
    getInvoiceUrl,
    { data: urlData, error: urlError },
  ] = useInstructorInvoiceUrl();

  const isMobileSafari = (): boolean =>
    navigator.maxTouchPoints > 0 &&
    /(Macintosh|Iphone|iPad).*Safari/i.test(navigator.userAgent);

  useEffect(() => {
    if (urlData?.invoiceUrl.url) {
      window.open.apply(
        this,
        isMobileSafari()
          ? [urlData.invoiceUrl.url, "_self"]
          : [urlData.invoiceUrl.url],
      );
    }
    if (urlData?.invoiceUrl.url === null) {
      enqueueSnackbar("Invoice pdf not currently available for download", {
        variant: "error",
        autoHideDuration: 2000,
      });
    }

    if (urlError) {
      enqueueSnackbar("Error fetching invoice pdf", {
        variant: "error",
        autoHideDuration: 2000,
      });
    }
  }, [urlData, urlError]);

  const handleClickDownload = async (invoiceId: string) => {
    trackEvent({
      eventCategory: "Invoices",
      eventAction: "Button Click",
      eventLabel: "Download PDF",
    });

    const invoice = data?.instructor.invoices.find(
      invoice => invoice.id == invoiceId,
    );
    if (invoice) {
      await getInvoiceUrl({
        variables: {
          transactionKey: invoice.id,
        },
      });
    }
  };

  const invertedInvoices = data?.instructor.invoices.map(invoice => ({
    ...invoice,
    value: -invoice.value,
  }));

  return (
    <Grid container>
      <Grid item sm={12}>
        <Table
          invoices={invertedInvoices}
          loading={loading}
          onClickDownload={handleClickDownload}
          showPaid={false}
        />
      </Grid>
    </Grid>
  );
};

export default InstructorInvoices;
